import { render, staticRenderFns } from "./AddBuyout.vue?vue&type=template&id=98d8be52&"
import script from "./AddBuyout.vue?vue&type=script&lang=ts&"
export * from "./AddBuyout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports